import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Bars, Xmark } from '@unified-checkout/design-system/icons/index';

import {
  mainNavLinks,
  secNavLinks,
} from 'apps/customer/src/constants';
import { NavItem } from '../navItem';
import styles from './mobile-nav-menu.module.scss';
import { OneClick } from 'apps/customer/src/assets/icons';
import { UserInfo } from '../UserInfo';
import { useCurrentNotification, useLiveChat } from 'apps/customer/src/hooks';
import { NotificationSystem } from '../announcements/NotificationSystem';

export const MobileNavMenu = () => {
  const navigate = useNavigate();
  const pathname = useLocation().pathname;

  const { currentNotification, setCurrentNotification } =
    useCurrentNotification();
  const [isMenuExpanded, setIsMenuExpanded] = useState(false);

  const expandBtnHandler = () => {
    setIsMenuExpanded(!isMenuExpanded);
  };

  const logoClickHandler = () => {
    navigate('/payment-method');
  };

  const closeNotificationHandler = () => {
    setCurrentNotification(undefined);
    expandBtnHandler();
  };

  const { chatToggler } = useLiveChat();

  return (
    <>
      <nav
        className={styles['mobile-nav-container']}
        data-mobile-nav-expanded={isMenuExpanded}
      >
        <div className={styles['mobile-nav-container__mobile-nav-menu']}>
          <div
            className={styles['mobile-nav-container__mobile-nav-menu__logo']}
            onClick={logoClickHandler}
          >
            {OneClick}
          </div>

          <div
            className={
              styles['mobile-nav-container__mobile-nav-menu__collapse-btn']
            }
            onClick={expandBtnHandler}
          >
            {isMenuExpanded ? Xmark : Bars}
          </div>
        </div>

        {isMenuExpanded && (
          <>
            <UserInfo />
            <NotificationSystem
              currentNotification={currentNotification}
              onClose={closeNotificationHandler}
            />
            <div className={styles['mobile-nav-container__nav-links']}>
              {mainNavLinks.map((navLink, i: number) => {
                return (
                  <NavItem
                    key={`nav-link-${i}`}
                    icon={navLink.icon}
                    label={navLink.label}
                    route={navLink.route}
                    active={pathname === navLink.route}
                    onClick={expandBtnHandler}
                  />
                );
              })}
              {secNavLinks.map((navLink, i: number) => {
                return (
                  <NavItem
                    key={`sec-link-${i}`}
                    icon={navLink.icon}
                    label={navLink.label}
                    route={navLink.route}
                    active={pathname === navLink.route}
                    onClick={() => {
                      expandBtnHandler(), !navLink.route && chatToggler();
                    }}
                  />
                );
              })}
            </div>
          </>
        )}
      </nav>
    </>
  );
};
